import { PostGridEvent } from "../events/post_grid_event.js";
import { throttle } from "../utilities/debounce.js";
import { updateTitle } from "../utilities/meta.js";
import { nextMicrotask } from "../utilities/scheduling.js";
import { updateUrlParam } from "../utilities/url.js";
import { DickTokComponent } from "./Component.js";
import { defineElement } from "./registry.js";

export class DickTokSearch extends DickTokComponent {
  static services = ["PostApiService"];

  static targets = ["input", "inputIcon"];

  connectedCallback() {
    super.connectedCallback();

    // This should use the static targets configuration, but the backend
    // isn't set up to support adding this directly to Component templates
    // and it's not worth doing right now.
    this.postGridTarget = this.getElement("dt-postgrid");

    // Could possibly do this with data-action but it hasn't been tested with
    // custom events, so just set this up here.
    this.addEventListener(
      PostGridEvent.OPEN_POST,
      (event) => this.#openPosts(event),
      { signal: this.disconnectSignal },
    );
  }

  async search() {
    const query = this.inputTarget.value.trim();
    this.#setIconSearching();
    // Clear next token so the PostGrid doesn't use it to load more thumbnails
    // using the old token when the thumbnails are cleared.
    this.postGridTarget.next = null;
    // Since the PostGrid uses an attribute change callback to update internal
    // state when next is changed, wait for callback to fire.
    await nextMicrotask();
    // Remove existing thumbnails
    this.postGridTarget.replaceChildren();
    // Update the URL query param
    updateUrlParam("query", query);
    // Update the document title
    // This should match format in pages/search.php getSearchAction()
    updateTitle(`${query} | DickTok`);
    // Load initial posts for query and get pagination token
    // Subsequent loading will use pagination and is handled by PostGrid
    const { items, next } = await this.postApiService.searchPosts(
      query,
      "thumbnail",
    );
    // User updated the search query and results are stale, break
    if (this.inputTarget.value.trim() !== query) {
      return;
    }
    this.#setIconComplete();
    // Add new thumbnails
    this.postGridTarget.replaceChildren(...items);
    // Set next so that PostGrid loads posts on scroll using token
    this.postGridTarget.next = next;
  }

  searchWhenFinished = throttle(() => {
    this.search();
  }, 300);

  #openPosts({ target }) {
    open(`/search/posts?token=${target.dataset.token}`, "_self");
  }

  #setIconSearching() {
    this.inputIconTarget.classList.replace(
      "fa-magnifying-glass",
      "fa-spinner-third",
    );
    this.inputIconTarget.classList.add("fa-spin");
  }

  #setIconComplete() {
    this.inputIconTarget.classList.remove("fa-spin");
    this.inputIconTarget.classList.replace(
      "fa-spinner-third",
      "fa-magnifying-glass",
    );
  }
}

defineElement("dicktok-search", DickTokSearch);
